import React, {CSSProperties, PureComponent} from 'react'
import PropTypes from 'prop-types'
import cxs from 'cxs/component'
import Theme from 'Theme'
import {t, T} from 'helpers/i18n'
import {Search, SortType} from 'helpers/FuzzySearch'
import {narutalSort} from 'helpers/Utils'
import {Filter, SearchInput} from 'components'
import {Icon, Loading} from 'elements'
import {AddButton} from 'Styles'
import theme from 'Theme'
import './Table.css'

interface Props<P> {
  width?: any
  items: P[]
  header?: string[]
  filters?: {
    name: string
    filter(item: P): boolean
  }[]
  search?: boolean
  loading?: boolean

  onSelectItem?(item: P): void

  onCreate?(): void

  keyExtractor(item: P): string

  // onChange(name: string, value: string): void
  handleSearch?(searchTerm: string): void
}

interface State<P> {
  items: P[]
  sortType: string | undefined
  sortHeader: string | undefined
  searchTerm: string | undefined
  filterSelected: number
  isMobile: boolean
}

class Table<P> extends PureComponent<Props<P>, State<P>> {
  static defaultProps = {
    search: true
  }

  state: State<P> = {
    items: this.props.items,
    sortType: undefined,
    sortHeader: undefined,
    searchTerm: undefined,
    filterSelected: 0,
    isMobile: false
  }

  componentWillReceiveProps(nextProps: Props<P>) {
    if (nextProps.items !== this.state.items)
      this.setState({items: nextProps.items})
  }

  componentDidMount() {
    this.onHandleResize.call(this)
    window.addEventListener('resize', this.onHandleResize.bind(this))
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onHandleResize.bind(this))
  }

  onHandleResize() {
    const isMobile = window.matchMedia('(max-width: 719px)').matches ? true : false
    this.setState({isMobile})
  }

  handleFilter = (value: number) => {
    this.setState({filterSelected: value})
  }

  handleSearch = (searchTerm: string) => {
    this.setState({searchTerm: searchTerm || undefined})
  }

  handleSelectHead = (head: string) => {
    let sort: string | undefined = undefined
    if (head !== this.state.sortHeader) sort = SortType.Asc
    if (head === this.state.sortHeader && this.state.sortType !== SortType.Desc)
      sort = SortType.Desc
    this.setState({sortType: sort, sortHeader: sort ? head : undefined})
  }

  filteredItems = (): P[] => {
    const {items, filterSelected, sortType, sortHeader, searchTerm} = this.state
    const {filters} = this.props
    const header = this.props.header || Object.keys(this.props.items[0])

    let filteredItems = items
    if (filters) {
      filteredItems = filteredItems.filter(filters[filterSelected].filter)
    }
    if (sortHeader) {
      filteredItems = narutalSort(
        filteredItems,
        sortHeader,
        sortType === SortType.Desc
      )
    }
    if (searchTerm) {
      filteredItems = Search(searchTerm, filteredItems, header) as P[]
    }
    return filteredItems
  }

  translated = (item: P): P => {
    // console.log('items', item)
    // console.log('t(String(item))', t(String(item)))
    // console.log('t(String(item)).includes', t(String(item)).includes('@@'))
    if (item && !t(String(item)).includes('@@')) {
      // console.log('traducido', t(String(item)))
      return t(String(item))
    }
    return item
  }

  reduce = (item: P): P => {
    // console.log(`type of item ${item}`, typeof item)
    return item
  }

  render() {
    const {
      keyExtractor,
      onSelectItem,
      onCreate,
      filters,
      search,
      loading
    } = this.props
    const {sortType, sortHeader, filterSelected, isMobile} = this.state
    const items = this.filteredItems()
    const header = this.props.header || Object.keys(this.props.items[0])

    if (loading) return <Loading/>

    const handle = this.props.handleSearch ? this.props.handleSearch : this.handleSearch

    return (
      <Wrapper>
        <Bar>
          {search && <StyledSearchInput onChange={handle}/>}
          {filters && (
            <Filter
              filters={filters}
              onSelect={this.handleFilter}
              selectedFilter={filterSelected}
            />
          )}
        </Bar>

        {items.length>0 && !isMobile &&
        <StyledTable
          onCreate={onCreate}
        >
            <thead>
            <tr>
              {header.map((head, index) => (
                <Th key={head} onClick={() => this.handleSelectHead(head)}>
                  {T(head)}
                  <Sort>
                    {head === sortHeader &&
                    (sortType === SortType.Asc ? <SortAsc/> : <SortDesc/>)}
                  </Sort>
                </Th>
              ))}
            </tr>
            </thead>

            <tbody>
            {items.map((item, iter) => (
              <Tr
                key={keyExtractor(item)}
                onClick={onSelectItem && (() => onSelectItem(item))}>
                {header.map((head, index) => <Td key={index}>{item[head]}</Td>)}
              </Tr>
            ))}
            </tbody>
        </StyledTable>}

        {items.length===0 && !isMobile &&
          <div>No hay datos que mostrar</div>
        }

        {isMobile && (
          <div
            style={{
              /*backgroundColor: 'yellow',*/
              marginBottom: Theme.common.size.bar*2 + 'px'
            }}
            /*className={classNames('table', 'striped', 'hover')}*/
          >
            {items.map((item, index) => {
            return (
            <div
            onClick={onSelectItem && (() => onSelectItem(item))}
            key={keyExtractor(item)}
            >
            <Row

            >
            {
              header.map((head, indice) => (
                <Column
                  key={indice}
                >
                          <span
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              /*backgroundColor: '#52c0df'*/
                            }}
                            onClick={onSelectItem && (() => onSelectItem(item))}
                            key={head}>
                            <span
                              style={{
                                fontWeight: 'bold',
                                maxWidth: '30%',
                                minWidth: '125px',
                                display: 'inlineBlock',
                                /*backgroundColor: '#f489f0',*/
                                flexGrow: 0,
                                flexShrink: 0
                              }}
                              className="header"
                            >
                              {t(head)}:
                            </span>
                            <span
                              style={{
                                flexGrow: 0,
                                flexShrink: 0,
                                textTransform: 'none',
                                /*backgroundColor: 'yellow'*/
                              }}
                            >{item[head]}</span>
                        </span>
                </Column>
              ))
            }
            </Row>
            </div>
            )
          })}
          </div>

        )
        }

        {onCreate && (
          <AddButton primary onClick={onCreate}>
            {T('add')}
          </AddButton>
        )}
      </Wrapper>
    )
  }
}

export default Table

const Row = ({header = false, children}) => {
  const headerStyle = header? {
    boxShadow: `0 1px 2px 0 ${theme.color.hairline}`,
  } as CSSProperties : undefined

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        width: '100%',
        padding: '12px',
        borderBottom: `1px solid ${theme.color.hairline}`,
        boxSizing: 'border-box',
        ...headerStyle,
      }}
      /*className={classNames('table__row', {'table__row--header': header})}*/
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          /*flexWrap: 'nowrap',*/
          /*padding: '12px',*/
          /*borderBottom: `1px solid ${theme.color.hairline}`,*/
          /*boxSizing: 'borderBox',*/
          /*...headerStyle,*/
          /*backgroundColor: '#e1b467',*/

        }}
        /*className="wrapper"*/
        >
        {children}
      </div>
    </div>
  )
}

const Column = ({children}) => (
  <div
    /*className="column"*/
  >
    {children}
  </div>
)

const Wrapper = cxs('div')(
  ({width}) =>
    ({
      minHeight: '200px',
      width: width ? width : '100%'
    } as CSSProperties)
)

const Bar = cxs('div')({
  display: 'flex',
  borderBottom: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
} as CSSProperties)

const StyledSearchInput = cxs(SearchInput)({
  flex: 1,
  /*borderRight: `${Theme.size.hairline} solid ${Theme.color.hairline}`*/
} as CSSProperties)

const StyledTable = cxs('table')(
  ({onCreate}) =>
    ({
      width: '100%',
      ...onCreate ? {marginBottom: Theme.size.bar} : undefined,
      ' tr:nth-child(even)': {
        backgroundColor: Theme.color.rowBackground
      }
    })
)

const StyledDiv = cxs('div')(
    ({
      ' :hover div': {
        backgroundColor: Theme.color.rowBackground
      },
      ' :nth-child(odd)': {
        backgroundColor: Theme.color.hairline
      },
    } as CSSProperties)
)

StyledTable.propTypes = {
  onCreate: PropTypes.func
}

const Th = cxs('th')({
  padding: Theme.size.space[1],
  borderBottom: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
  cursor: 'pointer'
} as CSSProperties)

const Sort = cxs('span')({
  padding: `0 ${Theme.size.space[1]}`,
  position: 'relative',
  '> icon': {
    left: '2px',
    position: 'absolute',
    lineHeight: 1.25,
    padding: 0
  }
} as CSSProperties)

const sortIcon = props => (
  <Icon {...props} name="back" size={parseInt(Theme.fontSize.small, 0)}/>
)

const SortAsc = cxs(sortIcon)({
  transform: 'rotate(90deg)'
} as CSSProperties)

const SortDesc = cxs(sortIcon)({
  transform: 'rotate(-90deg)'
} as CSSProperties)

const Tr = cxs('tr')(
  ({onClick}) =>
    ({
      ...onClick ? {cursor: 'pointer'} : undefined
    } as CSSProperties)
)

const Td = cxs('td')({
  padding: Theme.size.space[1],
  textAlign: 'center',
  ':last-child': {
    /*textAlign: 'right',*/
    whiteSpace: 'nowrap'
  }
} as CSSProperties)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Table.tsx